import { Box } from "@mui/material";
import useIsIntegrated from "../../../../api/hooks/useIsIntegrated";
import useMSSP from "../../../../api/hooks/useMSSP";
import ClearFiltersButton from "../../../../components/filters/ClearFiltersButton";
import { ComplexEntityTypes } from "../../../../utils/constants";
import { ALL_ENTITIES } from "../entityOverviewPage/TableView/EntitiesOverviewTableView";
import { useEntities } from "../hooks/useEntities";
import { getAllEntitiesFilters } from "./allEntitiesFilters";
import { getAppFilters } from "./appFilters";
import { getDatastoreFilters } from "./datastoreFilters";
import { getHostFilters } from "./hostFilters";
import { getNHIFilters } from "./nhiFilters";
import { getServerFilters } from "./serverFilters";
import { getSharedFilters, getSharedFiltersMultiTenant } from "./sharedFilters";
import { getUserFilters } from "./userFilters";
import { pastTimeValues } from "./utils";
export const pastTimeOptions = Object.entries(pastTimeValues).map(
  ([name, info]) => ({
    name: name,
    label: info.label,
    displayName: info.label,
  })
);

const buildFiltersForEntityType = (params, sharedFilters) => {
  const filters = [...sharedFilters];
  switch (params.entityType) {
    case ALL_ENTITIES:
      filters.push(
        ...getAllEntitiesFilters({
          ...params,
        })
      );
      break;
    case ComplexEntityTypes.HOST:
      filters.push(...getHostFilters(params));
      break;
    case ComplexEntityTypes.USER:
      filters.push(...getUserFilters(params));
      break;
    case ComplexEntityTypes.SERVER:
      filters.push(...getServerFilters(params));
      break;
    case ComplexEntityTypes.DATA_STORE:
      filters.push(...getDatastoreFilters(params));
      break;
    case ComplexEntityTypes.NONHUMAN_IDENTITY:
      filters.push(
        ...getNHIFilters({ ...params, userEntities: params.userEntities })
      );
      break;
    case ComplexEntityTypes.APP:
      filters.push(...getAppFilters(params));
      break;
    default:
      break;
  }

  return filters;
};

export const getFilters = (params) => {
  const sharedFilters = getSharedFilters(params);
  return buildFiltersForEntityType(params, sharedFilters);
};

export const getFiltersMultiTenant = (params) => {
  const sharedFilters = getSharedFiltersMultiTenant(params);
  return buildFiltersForEntityType(params, sharedFilters);
};

export default function EntityTypeRegularFilters({
  entityType,
  fetchedEntities,
  assets,
  appliedFilters,
  setAppliedFilters,
  filterAndOrLogics,
  setFilterAndOrLogics,
  allLabels,
  allCustomTags,
}) {
  const { hasMultipleSelectedTenants } = useMSSP();
  const { integrations, isIntegratedLoading } = useIsIntegrated();
  const { useQueryForEntitiesByType } = useEntities();

  const { data: userEntities } = useQueryForEntitiesByType({
    type: ComplexEntityTypes.USER,
    enabled: entityType === ComplexEntityTypes.NONHUMAN_IDENTITY,
  });

  const filters = hasMultipleSelectedTenants
    ? getFiltersMultiTenant({
        entityType: entityType,
        assets: assets,
        fetchedEntities: fetchedEntities,
        appliedFilters: appliedFilters,
        setAppliedFilters: setAppliedFilters,
        filterAndOrLogics: filterAndOrLogics,
        setFilterAndOrLogics: setFilterAndOrLogics,
        allLabels: allLabels,
        integrations: integrations,
        userEntities: userEntities,
      })
    : getFilters({
        entityType: entityType,
        assets: assets,
        fetchedEntities: fetchedEntities,
        appliedFilters: appliedFilters,
        setAppliedFilters: setAppliedFilters,
        filterAndOrLogics: filterAndOrLogics,
        setFilterAndOrLogics: setFilterAndOrLogics,
        allLabels: allLabels,
        allCustomTags: allCustomTags,
        integrations: integrations,
        userEntities: userEntities,
      });

  return (
    <Box display="flex" flexWrap="wrap" alignItems="center" gap={1}>
      {filters.map((filter, index) => (
        <Box key={index} width="min-content">
          {filter}
        </Box>
      ))}
      <ClearFiltersButton
        appliedFilters={appliedFilters}
        setAppliedFilters={setAppliedFilters}
      />
    </Box>
  );
}
